import React, { useState } from "react";
import { Link } from "gatsby";
import { PATH } from "~/constant/path";
import { colors } from "~/utils/colors";
import { breakPoints, headerHeight } from "~/utils/variables";
import { FiDownload } from "@react-icons/all-files/fi/FiDownload";
import { FiMail } from "@react-icons/all-files/fi/FiMail";
import { FiCalendar } from "@react-icons/all-files/fi/FiCalendar";
import { FiMenu } from "@react-icons/all-files/fi/FiMenu";
import { FiX } from "@react-icons/all-files/fi/FiX";
import { useLocation } from "@reach/router";
import logoHorizontal from "~/images/logo-horizontal.svg";

type Props = {
  isTopPage?: Boolean;
};

export const Header: React.FC<Props> = ({ isTopPage = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const location = useLocation();

  console.log(location.pathname);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setIsMenuOpen(true);
    }
  };

  const closeMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsMenuOpen(false);
      setIsClosing(false);
    }, 300);
  };

  return (
    <>
      <style jsx>{`
        .wrapper {
          background-color: ${colors.white};
          padding: 14px 30px;
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 100;
          box-shadow: 0 0 16px rgba(0, 0, 0, 0.04);
        }
        .container {
          align-items: center;
          display: flex;
        }
        .logo {
          display: block;
          height: 32px;
          width: auto;
        }
        .logo :global(img) {
          display: block;
          height: 32px;
          width: auto;
        }
        .navigation {
          margin-left: auto;
        }
        .navigationList {
          align-items: center;
          display: flex;
        }
        .navigationListItem {
          display: block;
        }
        .navigationListItem :global(a) {
          color: ${colors.defaultText};
          font-size: 14px;
          font-weight: 700;
          transition: all 0.2s ease-out;
        }
        .navigationListItem :global(a:hover) {
          opacity: 0.8;
          text-decoration: underline;
        }
        .navigationListItem :global(a:visited) {
          color: ${colors.defaultText};
          font-size: 14px;
          font-weight: 700;
          transition: all 0.2s ease-out;
        }
        .navigationListItem :global(a .en) {
          font-size: 1.16em;
        }
        .navigationListItem + .navigationListItem {
          margin-left: 30px;
        }
        .cvButtonContainerWrapper {
          display: flex;
          gap: 8px;
        }
        .cvButtonContainer {
          display: block;
        }
        .cvButtonContainer :global(a) {
          display: block;
          position: relative;
          align-items: center;
          background-image: ${colors.brandGradient};
          background-color: ${colors.brand};
          border-radius: 50px;
          display: flex;
          font-size: 14px;
          font-weight: 500;
          line-height: 1;
          justify-content: center;
          padding: 6px 22px;
          height: 38px;
          position: relative;
          text-align: center;
          text-decoration: none;
          transition: all 0.2s ease-out;
        }
        .cvButtonContainer :global(a:hover) {
          opacity: 0.85;
          text-decoration: none;
          transform: translate3d(0, -1px, 0);
        }
        .cvButtonContainer :global(a:before) {
          background-color: ${colors.brandGradient};
          border-radius: 50px;
          content: "";
          left: 1px;
          height: calc(100% - 2px);
          position: absolute;
          top: 1px;
          width: calc(100% - 2px);
        }
        .cvButtonText {
          color: ${colors.white};
          display: block;
          position: relative;
          z-index: 1;
        }
        .inquiryButton :global(a) {
          border: 1px solid #e55c00;
          background-color: transparent;
          background-image: none;
        }
        .inquiryButton :global(a:before) {
          background-color: transparent;
        }
        .inquiryButton .cvButtonText {
          color: #e55c00;
        }
        .inquiryButton :global(a:hover) {
          opacity: 0.85;
          transform: translate3d(0, -1px, 0);
        }
        .hamburgerButton {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          margin-left: auto;
          position: relative;
          z-index: 1;
          flex-shrink: 0;
          min-width: 44px;
          min-height: 44px;
          align-items: center;
          justify-content: center;
          touch-action: manipulation;
          -webkit-tap-highlight-color: transparent;
        }
        .menuOverlay {
          display: none;
        }
        .mobileNavigation {
          display: none;
        }
        @media (max-width: 1280px) {
          .navigation {
            display: none;
          }
          .hamburgerButton {
            display: flex;
          }
          .menuOverlay {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 199;
            animation: fadeIn 0.3s ease-out;
          }
          .menuOverlay.closing {
            animation: fadeOut 0.3s ease-out;
          }
          .mobileNavigation {
            display: block;
            position: fixed;
            top: 0;
            right: 0;
            width: 80%;
            max-width: 300px;
            height: 100%;
            background-color: ${colors.white};
            z-index: 200;
            padding: 80px 20px 20px;
            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
            overflow-y: auto;
            animation: slideIn 0.3s ease-out;
          }
          .mobileNavigation.closing {
            animation: slideOut 0.3s ease-out;
          }
          .closeButton {
            position: absolute;
            top: 20px;
            right: 20px;
            background: none;
            border: none;
            cursor: pointer;
            padding: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: opacity 0.2s ease-out;
          }
          .closeButton:hover {
            opacity: 0.7;
          }
          .mobileNavigationList {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          .mobileNavigationListItem {
            margin-bottom: 20px;
          }
          .mobileNavigationListItem :global(a) {
            color: ${colors.defaultText};
            font-size: 16px;
            font-weight: 700;
            text-decoration: none;
            display: block;
            padding: 10px 0;
            transition: all 0.2s ease-out;
            text-align: center;
          }
          .mobileNavigationListItem :global(a:hover) {
            opacity: 0.8;
            text-decoration: underline;
          }
          .mobileNavigationListItem :global(a:visited) {
            color: ${colors.defaultText};
          }
          .mobileCvButtonContainerWrapper {
            display: flex;
            flex-direction: column;
            gap: 15px;
            margin-top: 40px;
          }
          .mobileCvButtonContainer {
            display: block;
          }
          .mobileCvButtonContainer :global(a),
          .mobileCvButtonContainer :global(a:visited),
          .mobileCvButtonContainer :global(a:active) {
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: ${colors.brandGradient};
            background-color: ${colors.brand};
            border-radius: 50px;
            font-size: 16px;
            font-weight: 500;
            line-height: 1;
            padding: 12px 24px;
            height: 48px;
            text-decoration: none;
            transition: all 0.2s ease-out;
          }
          .mobileCvButtonContainer :global(a:hover) {
            opacity: 0.85;
            text-decoration: none;
            transform: translate3d(0, -1px, 0);
          }
          .mobileCvButtonContainer.inquiryButton :global(a),
          .mobileCvButtonContainer.inquiryButton :global(a:visited),
          .mobileCvButtonContainer.inquiryButton :global(a:active) {
            border: 1px solid #e55c00;
            background-color: transparent;
            background-image: none;
            text-decoration: none;
          }
          .mobileCvButtonContainer.inquiryButton :global(a:hover) {
            text-decoration: none;
          }
          .mobileCvButtonContainer.inquiryButton .cvButtonText {
            color: #e55c00;
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          @keyframes slideIn {
            from {
              transform: translateX(100%);
            }
            to {
              transform: translateX(0);
            }
          }
          @keyframes slideOut {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(100%);
            }
          }
          @keyframes fadeOut {
            from {
              opacity: 1;
            }
            to {
              opacity: 0;
            }
          }
        }
        @media (${breakPoints.sp}) {
          .wrapper {
            padding: 14px 20px;
            box-shadow: none;
            min-height: ${headerHeight.mobile}px;
          }
        }
      `}</style>
      <header className="wrapper">
        <div className="container">
          <Link to="/" onClick={closeMenu}>
            <span className="logo">
              <img src={logoHorizontal} alt="Refcome" />
            </span>
          </Link>
          <nav className="navigation">
            <ul className="navigationList">
              <li className="navigationListItem">
                <Link to={PATH.CASES.to}>導入事例</Link>
              </li>
              <li className="navigationListItem">
                <Link to={PATH.EVENTS.to}>セミナー・イベント</Link>
              </li>
              <li className="navigationListItem">
                <Link to={PATH.DOWNLOADS.to}>{PATH.DOWNLOADS.name}</Link>
              </li>
              <li className="navigationListItem">
                <Link to={PATH.INSIGHT.to}>{PATH.INSIGHT.name}</Link>
              </li>
              <li className="navigationListItem">
                <div className="cvButtonContainerWrapper">
                  <span className="cvButtonContainer">
                    <Link to={PATH.REQUEST.to}>
                      <span className="cvButtonText">資料をダウンロード</span>
                      <FiDownload style={{ fontSize: "16px", marginLeft: "4px", color: `${colors.white}` }} />
                    </Link>
                  </span>
                  <span className="cvButtonContainer inquiryButton">
                    <Link to={PATH.MEETING_BOOKING.websiteTo}>
                      <span className="cvButtonText">オンライン相談を予約</span>
                      <FiCalendar style={{ fontSize: "16px", marginLeft: "4px", color: "#E55C00" }} />
                    </Link>
                  </span>
                  <span className="cvButtonContainer inquiryButton">
                    <Link to="/inquiry/contact">
                      <span className="cvButtonText">お問い合わせ</span>
                      <FiMail style={{ fontSize: "16px", marginLeft: "4px", color: "#E55C00" }} />
                    </Link>
                  </span>
                </div>
              </li>
            </ul>
          </nav>
          <button className="hamburgerButton" type="button" onClick={toggleMenu} aria-label="メニュー">
            {isMenuOpen ? (
              <FiX style={{ fontSize: "24px", color: `${colors.defaultText}` }} />
            ) : (
              <FiMenu style={{ fontSize: "24px", color: `${colors.defaultText}` }} />
            )}
          </button>
        </div>
      </header>
      {(isMenuOpen || isClosing) && (
        <>
          <div className={`menuOverlay ${isClosing ? "closing" : ""}`} onClick={closeMenu}></div>
          <nav className={`mobileNavigation ${isClosing ? "closing" : ""}`}>
            <button className="closeButton" onClick={closeMenu} aria-label="メニューを閉じる">
              <FiX style={{ fontSize: "24px", color: `${colors.defaultText}` }} />
            </button>
            <ul className="mobileNavigationList">
              <li className="mobileNavigationListItem">
                <Link to={PATH.CASES.to} onClick={closeMenu}>導入事例</Link>
              </li>
              <li className="mobileNavigationListItem">
                <Link to={PATH.EVENTS.to} onClick={closeMenu}>セミナー・イベント</Link>
              </li>
              <li className="mobileNavigationListItem">
                <Link to={PATH.DOWNLOADS.to} onClick={closeMenu}>{PATH.DOWNLOADS.name}</Link>
              </li>
              <li className="mobileNavigationListItem">
                <Link to={PATH.INSIGHT.to} onClick={closeMenu}>{PATH.INSIGHT.name}</Link>
              </li>
              <li className="mobileNavigationListItem">
                <div className="mobileCvButtonContainerWrapper">
                  <span className="mobileCvButtonContainer">
                    <Link to={PATH.REQUEST.to} onClick={closeMenu}>
                      <span className="cvButtonText">資料をダウンロード</span>
                      <FiDownload style={{ fontSize: "16px", marginLeft: "4px", color: `${colors.white}` }} />
                    </Link>
                  </span>
                  <span className="mobileCvButtonContainer inquiryButton">
                    <Link to={PATH.MEETING_BOOKING.websiteTo} onClick={closeMenu}>
                      <span className="cvButtonText">オンライン相談を予約</span>
                      <FiCalendar style={{ fontSize: "16px", marginLeft: "4px", color: "#E55C00" }} />
                    </Link>
                  </span>
                  <span className="mobileCvButtonContainer inquiryButton">
                    <Link to="/inquiry/contact" onClick={closeMenu}>
                      <span className="cvButtonText">お問い合わせ</span>
                      <FiMail style={{ fontSize: "16px", marginLeft: "4px", color: "#E55C00" }} />
                    </Link>
                  </span>
                </div>
              </li>
            </ul>
          </nav>
        </>
      )}
    </>
  );
};
